import { store } from '@/vame.js'

export default class VueLogo extends store.Component {
  static create (options = {}) {
    return {
      kind: 'vue-logo',
      x: options.x || 0,
      y: options.y || 0,
      width: options.width || 16,
      height: options.height || 16
    }
  }
}
